module.exports = __webpack_public_path__ + "img/06.af840218.jpg";